import { request } from '@/utils/request'

export function trackingHttpApi(data){
  return request({url:'/web/tracking/http-api-collect.do', method:'post', data})
}
